import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Typography, Grid, Paper, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
interface PortalProps {
  title: string | undefined;
  employee?: JSX.Element;
  buttonToRender?: JSX.Element;
}

const HeaderPortal = ({ title, employee, buttonToRender }: PortalProps) => {
  const theme = useTheme();
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return portalHeader ? (
    ReactDOM.createPortal(
      <Grid
        style={{
          borderRadius: "12px",
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          gap: "10px",
          padding: "10px",
          alignItems: "center",
        }}
      >
        <Grid>
          <Typography
            variant="h3"
            sx={{
              display: "WebkitBox",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              lineHeight: "1",
            }}
          >
            {title}
          </Typography>
          {buttonToRender}
        </Grid>
        <Divider
          flexItem
          orientation={"vertical"}
        />
        <Grid>{employee}</Grid>
      </Grid>,
      portalHeader
    )
  ) : (
    <></>
  );
};

export default HeaderPortal;
